import React from "react";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60]">Legal</div>
      <h1 className="font-serif-display text-4xl sm:text-5xl tracking-tight mt-2">Terms of Service</h1>
      <p className="text-xs text-[#5F6C60] mt-3">Last updated: February 25, 2026</p>

      <div className="prose mt-10 max-w-none text-[#2C352D] leading-relaxed space-y-6 text-[15px]">
        <p>Welcome to Massage Savings ("we", "us", "our"). By accessing or using our website and services, you agree to be bound by these Terms of Service.</p>

        <h2 className="font-serif-display text-2xl mt-8">1. Marketplace role</h2>
        <p>Massage Savings is a flat-fee listing marketplace. We do not take a cut of any deal redeemed through our platform. Customers contact massage providers directly to book and pay. We are not a party to any service contract between customers and providers.</p>

        <h2 className="font-serif-display text-2xl mt-8">2. Provider subscriptions</h2>
        <p>Individual therapists may list deals for $49.99/month per deal. Massage businesses may list deals for $99.99/month per deal. Listings are reviewed and require admin approval. After approval, a 3-day free trial begins; thereafter a subscription is required for the deal to remain visible. Featured (pin-to-top) placement may be purchased separately as a one-time add-on.</p>

        <h2 className="font-serif-display text-2xl mt-8">3. Provider responsibilities</h2>
        <p>Providers warrant that they are licensed and authorized to practice in their jurisdiction; that the deal description, pricing, location, and contact information are accurate; and that they will honor advertised deals.</p>

        <h2 className="font-serif-display text-2xl mt-8">4. Customer responsibilities</h2>
        <p>Customers are responsible for verifying provider credentials, the suitability of any massage service for their personal health condition, and for all payments made directly to providers.</p>

        <h2 className="font-serif-display text-2xl mt-8">5. Refunds and cancellations</h2>
        <p>Subscription fees are non-refundable except at our sole discretion. Service refunds are handled directly by the provider.</p>

        <h2 className="font-serif-display text-2xl mt-8">6. Account suspension</h2>
        <p>We may suspend or terminate any account that violates these Terms, posts misleading content, receives repeated complaints, or fails to honor advertised deals.</p>

        <h2 className="font-serif-display text-2xl mt-8">7. Disclaimer of warranties</h2>
        <p>The service is provided "as is" without warranties of any kind. We do not endorse any provider listed on our platform.</p>

        <h2 className="font-serif-display text-2xl mt-8">8. Limitation of liability</h2>
        <p>To the maximum extent permitted by law, Massage Savings is not liable for any indirect, incidental, or consequential damages arising from your use of the platform or any massage service booked through it.</p>

        <h2 className="font-serif-display text-2xl mt-8">9. Changes</h2>
        <p>We may update these Terms from time to time. Continued use of the platform constitutes acceptance of the revised Terms.</p>

        <h2 className="font-serif-display text-2xl mt-8">10. Contact</h2>
        <p>Questions? Reach us at <a href="mailto:legal@massagesavings.com" className="text-[#D97757] hover:underline">legal@massagesavings.com</a> or via the "Need a Therapist?" form on the site.</p>
      </div>
    </div>
  );
}
